/*
 * @Author: zgz
 * @Date: 2020-12-18 18:27:50
 * @LastEditors: zgz
 * @LastEditTime: 2021-01-31 10:44:52
 * @Description:
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'jquery'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import md5 from 'js-md5';
import BGHttp from './components/common/axios/config';
import Axios from "axios";
import store from './components/common/store'

import vueSwiper from 'vue-awesome-swiper' // 引入vue-awesome-swiper
import 'swiper/css/swiper.css' // 引入样式

Vue.use(vueSwiper)

Vue.prototype.DOMIN = "//www.tianxie18.com/api";
Vue.prototype.BGHttp = BGHttp;
Vue.prototype.Axios = Axios;
Vue.prototype.MD5 = md5;
Vue.config.productionTip = false
Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
  created: function () {
    window.store = this.$store;
    window.DOMIN = this.DOMIN;
    window.BGHttp = BGHttp;
    window.MD5 = md5;
  },
})



// WEBPACK FOOTER //
// ./src/main.js